// DatePickerFromTo.jsx
'use client';

import React, { useEffect, useCallback } from 'react';
import SmartDateRangeField from '../../DatePickers/SmartDateRangeField';

const pad = (n) => String(n).padStart(2, '0');
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
const addDays = (yyyyMMdd, days) => {
  const [y, m, d] = yyyyMMdd.split('-').map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1);
  dt.setDate(dt.getDate() + days);
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
};

export default function DatePickerFromTo({
  setCheckInDate,
  setCheckOutDate,
  checkInDate,
  checkOutDate,
  error,
  helperText,
}) {
  // initialize defaults once if empty
  useEffect(() => {
    if (!checkInDate || !checkOutDate) {
      const t = todayStr();
      setCheckInDate(t);
      setCheckOutDate(addDays(t, 1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rangeValue = [
    checkInDate ? String(checkInDate) : '',
    checkOutDate ? String(checkOutDate) : '',
  ];

  const handleRangeChange = useCallback(
    ([start, end]) => {
      setCheckInDate(start || '');
      setCheckOutDate(end || '');
    },
    [setCheckInDate, setCheckOutDate]
  );

  return (
    <div className="input-style-check" style={{ width: '100%' }}>
      <div className="d-flex justify-between px-10">
        <p className="text-12 fw-500 ls-2 lh-16">Pick-up Date</p>
      </div>

      <SmartDateRangeField
        type="date"
        value={rangeValue}
        setValue={handleRangeChange}
        minDate={todayStr()}              // block past dates; today allowed
        placeholder="Check-in — Check-out"
        showHint={false}
        editable={false}                  // prevent manual typing
        cleanable={false}                 // hide clear button
        sx={{
          border: error ? '1px solid red' : '1px solid transparent',
          borderRadius: 8,
          px: 1,
          fontSize: 14,
        }}
      // container={() => document.body} // uncomment if popup is clipped by overflow
      />

      {error && (
        <div style={{ color: 'red', fontSize: 11 }}>{helperText}</div>
      )}
    </div>
  );
}
